import React from 'react';
import './TableComponent.css';
import { Button } from './Button';
import { CustomTableProps } from '../../types/TableComponent.types';
import { useLanguage } from '../../context/languageContext';

const CustomTable: React.FC<CustomTableProps> = ({ data, columns, buttons, pages = { enabled: false } }) => {
    const { t } = useLanguage();
    return (
        <div className="table-container">
            <table className="data-table">
                <thead className='global-head'>
                    <tr key={1}>
                        {columns.map((column, index) => (
                            <th key={index}>{column.header}</th>
                        ))}
                        {
                            buttons.length ?
                                <th className='actions'>
                                    {t('common.actions')}
                                </th>
                                :
                                <></>
                        }

                    </tr>
                </thead>
                <tbody className='global-body'>
                    {data.map((item, index) => (
                        <tr key={index}>
                            {columns.map((column, index) => (
                                <td key={index}>{item[column.accessor]}</td>
                            ))}
                            {
                                buttons.length ?
                                    <td className='given-buttons'>
                                        {buttons.map((button, btnIndex) => (
                                            <span
                                                className='given-button'
                                                key={button.bc + btnIndex}
                                                style={{ backgroundColor: button.bcByRow ? button.bcByRow(item) : button.bc }}
                                                onClick={() => button.action.function(item[button.action.param])}
                                            >
                                                {button.buttonByRow ? button.buttonByRow(item) : button.button}
                                            </span>
                                        ))}
                                    </td>
                                    :
                                    <>
                                    </>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            {pages.enabled && (
                <div className="pagination-controls">
                    <Button name={t('common.previous')} action={() => pages.onPageChange(pages.page - 1)} disabled={pages.page >= 1 ? false : true} />
                    <span>{`${t('common.page')} ${pages.page + 1}`}</span>
                    <select onChange={(e) => pages.onLimitChange(Number(e.target.value))} value={pages.limit} className='dropdown'>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </select>
                    <Button name={t('common.next')} action={() => pages.onPageChange(pages.page + 1)} />
                </div>
            )}
        </div>
    );
};

export default CustomTable;
